import { render, staticRenderFns } from "./independentLandmark.vue?vue&type=template&id=60257da9&scoped=true&"
import script from "./independentLandmark.vue?vue&type=script&lang=ts&"
export * from "./independentLandmark.vue?vue&type=script&lang=ts&"
import style0 from "./independentLandmark.vue?vue&type=style&index=0&id=60257da9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60257da9",
  null
  
)

export default component.exports